<div class="filters-sidebar-container" [ngClass]="{'hidden-nav': isHidden}">
    <div class="sidebar-toggle" (click)="onSidebarToggle()">
        <span class="material-symbols-rounded">
            left_panel_close
            </span>
    </div>
    <div class="filters-sidebar">
        <h4 class="title">Filter Results</h4>

        <div class="list-container">
            <h5 class="sub-title">API</h5>
            <ul class="filters">
                <li>
                    <label class="checkbox-container no-count" (click)="onDomainFilterClick('core')">
                        <div class="filter-pill no-count" [class.active]="activeDomain === 'core'">
                            Core API
                        </div>
                    </label>
                    <label class="checkbox-container no-count" (click)="onDomainFilterClick('ally')">
                        <div class="filter-pill no-count" [class.active]="activeDomain === 'ally'">
                            Ally API
                        </div>
                    </label>
                </li>
            </ul>
        </div>

        <div class="list-container" *ngIf="versionsForActiveDomain.length > 1">
            <h5 class="sub-title">API Version</h5>
            <ul class="filters">
                <li>
                    <label class="checkbox-container no-count" *ngFor="let version of versionsForActiveDomain" (click)="onVersionFilterClick(version)">
                        <div class="filter-pill no-count" [class.active]="activeVersion === version">
                            {{ version }}
                        </div>
                    </label>
                </li>
            </ul>
        </div>

        <div class="list-container">
            <h5 class="sub-title">Group</h5>
            <ul class="filters">
                <li *ngFor="let group of groupFiltersWithCount">
                    <ng-container *ngIf="group.count > 0">
                        <label class="checkbox-container">
                            <div class="filter-pill">
                                {{ group.name }}
                                <input type="checkbox" value="{{ group.code }}" (change)="onFilterCheck($event)">
                                <div [ngClass]="{
                                    'filter-count': true,
                                    'filter-count-extended': group.count > 99
                                }">{{ group.count }}</div>
                            </div>
                        </label>
                    </ng-container>
                </li>
            </ul>
        </div>

        <div class="list-container">
            <h5 class="sub-title">Result Type</h5>
            <ul class="filters">
                <li *ngFor="let type of typeFiltersWithCount">
                    <ng-container *ngIf="type.count > 0">
                        <label class="checkbox-container">
                            <div class="filter-pill">
                                {{ type.name }}
                                <input type="checkbox" value="{{ type.name }}" (change)="onTypeFilterCheck($event)">
                                <div [ngClass]="{
                                    'filter-count': true,
                                    'filter-count-extended': type.count > 99
                                }">{{ type.count }}</div>
                            </div>
                        </label>
                    </ng-container>
                </li>
            </ul>
        </div>
    </div>
</div>
